import type { SupervisorFinding } from '@avisoma/shared';

/** Catalyst badge colour per supervisor finding status (entity badges and the Corrections tab). */
export const FINDING_STATUS_COLOR: Record<SupervisorFinding['status'], 'amber' | 'zinc' | 'green' | 'red' | 'blue' | 'violet'> = {
  proposed: 'amber',
  rejected: 'zinc',
  abstained: 'zinc',
  applied: 'green',
  reapplied: 'green',
  obsolete: 'zinc',
  stale: 'red',
  reverted: 'blue',
  dismissed: 'violet',
};

/** Catalyst badge colour per finding severity (the Corrections tab and the audit page). */
export const FINDING_SEVERITY_COLOR: Record<SupervisorFinding['severity'], 'red' | 'amber' | 'sky'> = {
  error: 'red',
  warning: 'amber',
  info: 'sky',
};
